import { render } from "./index.vue?vue&type=template&id=32e541f4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=32e541f4&lang=scss&scoped=true"

import exportComponent from "D:\\code\\csgj\\sjg-wine-h5限制提现\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e541f4"]])

export default __exports__